import { Component, OnInit, ChangeDetectorRef, Directive, EventEmitter, Output, Input, ViewChild, ViewChildren, QueryList, ElementRef, ChangeDetectionStrategy } from '@angular/core';

import { ActivatedRoute, Router } from '@angular/router';
import { HttpParams } from '@angular/common/http';
import { AccountService } from 'src/app/services/account/account.service';
import { SweetAlertService } from 'src/app/services/sweetalert/sweet-alert.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ExportService } from 'src/app/services/export/export.service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ReportsService } from 'src/app/services/reports/reports.service';
import { CookieService } from 'ngx-cookie-service';
import { BackOfficeService } from 'src/app/services/back-office/back-office.service';
import { formatDate } from '@angular/common';
import { compareDates } from 'src/app/shared/date-compare/date-compare';
import { Meta } from '@angular/platform-browser';
import { Title } from '@angular/platform-browser';

// Sorting 

interface verfiy { }

declare var YearlyPNLCalendar: any;

export type SortColumn = keyof verfiy | '';
export type SortDirection = 'asc' | 'desc' | '';
const rotate: { [key: string]: SortDirection } = { 'asc': 'desc', 'desc': 'asc' };

const compare = (v1: string | number, v2: string | number) => v1 < v2 ? -1 : v1 > v2 ? 1 : 0;

export interface SortEvent {
	column: SortColumn;
	direction: SortDirection;
}

@Directive({
    selector: 'th[sortable]',
    host: {
        '[class.asc]': 'direction === "asc"',
        '[class.desc]': 'direction === "desc"',
        '(click)': 'rotate()'
    },
    standalone: false
})

export class SortableHeader {

	@Input() sortable: SortColumn = '';
	@Input() direction: SortDirection = '';
	@Output() sort = new EventEmitter<SortEvent>();

	rotate() {
		this.direction = rotate[this.direction];
		this.sort.emit({ column: this.sortable, direction: this.direction });
	}
}



@Component({
    selector: 'app-verified-pnl',
    templateUrl: './verified-pnl.component.html',
    styleUrls: ['./verified-pnl.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class VerifiedPnlComponent implements OnInit {


	@ViewChildren(SortableHeader) headers: QueryList<SortableHeader>;

	// 
	active = 0;
	month: 5;
	equitydata: any[] = [];
	fno: any[] = [];
	clientdeatils: any;
	linkcode: any;
	equitytable: any;
	equityname: any;
	objectArray: any;
	datefrom: any;
	dateto: any;
	datetype: any;
	pnldata: any;
	startDate: any;
	endDate: any;
	segments: any;
	fnotable: any;
	equityheader: any[] = [];
	equityrow: any[] = [];
	fnoheader: any[] = [];
	fnorow: any[] = [];
	nsecomheader:any[]=[];
	nsecomrow:any[]=[];
	event: any;
	fnoname: any;
	com: any;
	comheader: any;
	comrow: any;
	comname: any;
	comtable: any;
	cur: any;
	curheader: any;
	currow: any;
	curname: any;
	curtable: any;
	nse:any;
	nseheader: any;
	nserow:any;
	nsename: any;
	nsetable: any
	nametype: any;
	maskname: string;
	enabled: any;
	datapresent: boolean = false;
	displayTrades: any;
	
	


	dataNotFound: boolean = false;

	hideHeatmap: boolean = false;

	randomString: string = '';
	searchSymbol: any;
	summary: any;

	profileLossArray: any[] = [];
	profileLossArrayFilter: any[] = [];
	otherCreditDebitArray: any[] = [];
	heatMapCalendarSegementOverAll: any[] = [];
	heatMapCalendarSegement: any[] = [];

	loading: boolean = false;
	segmentFnoMcx: boolean = false;
	profitLossForm: FormGroup;
	date = new Date();
	lastUpdatedPnl: any;
	breakdownCharges: any;

	pageStart: number = 0;
	pageHeight: number = 100;
	pageEnd: number = 50;
	pageBuffer: number = 20;

	page = 1;
	pageSize = 20;
	currentPage = 0;
	result: number;
	realisedPnl: number = 0;
	unRealisedPnl: number = 0;
	netRealisedPnl: number = 0;
	chargeAndTax: number = 0;
	otherCreaditDebit: number = 0;
	leapyear:boolean = false;

	todayDate = formatDate(new Date(), 'yyyy-MM-dd', 'en-US');
	heatmapCalendarYearInit: boolean = true;

	currentYear = new Date().getFullYear();
	lastYear = new Date().getFullYear() - 1;
	nextYear = new Date().getFullYear() + 1;
	currentMonth = new Date().getMonth() + 1;

	currentMonthNumber = new Date().getMonth();
	currentMonthDate = new Date().getDate();

	setFromDate = new Date().setFullYear(this.lastYear, 3, 1);
	setToDate = new Date().setFullYear(this.currentYear, this.currentMonthNumber, this.currentMonthDate);
	
	fromDate!: string;
	toDate!: string;
	pnlData: any[] = [];

	tooltipDate: string = '';
	eventPnl: string = '';

	filterYearMonthArray: any[] = [];
	filterMonthArray: any[] = [];

	selectedStartDate: any;
	selectedEndDate: any;

	calendarHeatmapArray = [];
	calendarHeatmapArrayRange = [];
	heatmapCalendarFinalArray: any[] = [];
	heatmapCalendarFinalRangeArray: any[] = [];
	filterHeatmapCalendarFinalRangeArray: any[] = [];

	originalFnorow: any[];
	originalEquityrow: any[];
	originalComrow: any[];
	originalCurrow: any[];
	originalNserow:any[];

	showSearchA: boolean = false;
	showSearchB: boolean = true;
	showSearchC: boolean = true;
	showSearchD: boolean = false;

	showSearchdup: boolean = false;

	holdingAverage: any[] = [];

	constructor(
		private router: Router,
		private changeDetectorRef: ChangeDetectorRef,
		private sweetAlertService: SweetAlertService,
		private route: ActivatedRoute,
		private accountService: AccountService,
		private fb: FormBuilder,
		private modalService: NgbModal,
		private reportService: ReportsService,
		private cookies: CookieService,
		private exportService: ExportService,
		private backOfficeService: BackOfficeService,
		private meta: Meta,
		private titleService: Title) {
		// this.meta.addTag({ name: 'description', content: 'This is the description for the component.' });
		// this.titleService.setTitle('New Title for My Component');
		this.meta.addTag({ property: 'og:image', content: 'https://aliceblueonline.com/wp-content/uploads/2022/10/logo.webp' });

		this.profitLossForm = this.fb.group({
			startDate: new FormControl('', Validators.required),
			endDate: new FormControl('', Validators.required),
			segment: new FormControl(''),
		})


	}

	ngOnInit(): void {
		this.route.queryParams.subscribe((param: any) => {
			if (param) {
				// console.log(param.code);
				this.linkcode = param.code;
			}
		})
		this.getLastElevanMonth();
		//this.getpnldata();
		this.getpnldatewise();
		// this.initHeatmapCalendar(this.currentMonth);
		this.getHeatMapCalendarYear();
		this.profitLossForm.patchValue({
			segment: 'eq',
			startDate: this.startDate,
			endDate: this.endDate,
			// pnl: 'combined',
		});

		this.showSearchD = true;

		this.selectedStartDate = this.startDate;
		this.selectedEndDate = this.endDate;
		// console.log(this.profitLossForm.value.startDate);
		this.getHeatMapCalendarRange();

		this.profitLossForm.patchValue({
			startDate: formatDate(new Date(this.date.getTime() - (30 * 24 * 60 * 60 * 1000)), 'yyyy-MM-dd', 'en-US'),
			endDate: formatDate(new Date(), 'yyyy-MM-dd', 'en-US'),
		});


	}


	// renderCalendar(fromDate: string, toDate: string): void {
	// 	const container = document.getElementById('verified-calendar');
	// 	if (!container || typeof YearlyPNLCalendar === 'undefined') {
	// 		return;
	// 	}
	// 	// const segmentKey = this.segments; // 'eq' or 'fno' or others
	// 	// 		const segmentData = data?.pnl?.[0]?.[0]?.[segmentKey] || [];
	// 	// 		this.heatMapCalendarSegementOverAll = data?.pnl?.[0]?.[0]?.[segmentKey]
	// 		if(this.active == 0) {
	// 			if(this.segments[0] =='eq') {
	// 			}
	// 			console.log('heatMapCalendarSegementOverAll', this.heatMapCalendarSegementOverAll)
	// 		}
	// 		if(this.segments == 'eq'){
	// 			console.log(this.heatMapCalendarSegementOverAll)

	// 		}

	// 	this.pnlData = this.heatMapCalendarSegementOverAll || [];
	// 	// console.log(this.pnlData)

	// 	YearlyPNLCalendar.init({
	// 		element: '#verified-calendar',
	// 		fromDate:fromDate,
	// 		toDate: toDate, 
	// 		data: this.pnlData
	// 	});
	// }

	renderCalendar(fromDate: string, toDate: string): void {
  const container = document.getElementById('verified-calendar');

  if (!container || typeof YearlyPNLCalendar === 'undefined') {
    return;
  }

  let segmentKey = '';

  // Decide active segment
  if (Array.isArray(this.segments)) {
    segmentKey = this.segments[this.active];
	console.log(this.fullPnlData[0])
  } else {
    segmentKey = this.segments; // direct string
  }

  const segmentObj = this.fullPnlData.find((item: any) =>
  Object.prototype.hasOwnProperty.call(item, segmentKey)
);
console.log(segmentObj)
//   console.log('Active segment:', segmentKey);

  // Get data for active segment
 const segmentData = segmentObj ? segmentObj[segmentKey] : [];

  // Transform data
  this.pnlData = segmentData.map((val: any) => ({
    date: val.date,
    pnl: `${val.pnl}`,
    color: val.color
  }));

//   console.log('Final pnlData:', this.pnlData);

  // Render calendar
  YearlyPNLCalendar.init({
    element: '#verified-calendar',
    fromDate: fromDate,
    toDate: toDate,
    data: this.pnlData
  });
}


	isLeapYear(year: number): boolean {
		return (year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0);
	  }

	  hasLeapFeb(year: number): boolean {
		const febDays = new Date(year, 2, 0).getDate(); // Get the number of days in February
		return febDays === 29;
	}


	getLastElevanMonth() {
		let array = [];
		let lastElevanMonth: any;
		for (let i = 11; i >= 0; i--) {
			let today = new Date();
			array.push(new Date(today.setMonth(today.getMonth() - i)));

		}

		if (array.length > 0) {
			lastElevanMonth = new Date(array[0]).getMonth();
		}

		this.setFromDate = new Date().setFullYear(this.lastYear, lastElevanMonth, 1);
	}

	//   get startDate(): FormControl {
	// 	return this.profitLossForm.get("startDate") as FormControl;
	//   }

	//   get endDate(): FormControl {
	// 	return this.profitLossForm.get("endDate") as FormControl;
	//   }
	fullPnlData:any[];

	getHeatMapCalendarYear() {
		// let from = formatDate(this.setFromDate, 'yyyy-MM-dd', 'en-US');
		// let to = formatDate(this.setToDate, 'yyyy-MM-dd', 'en-US');
		// let segment = 'overall';
		this.filterHeatmapCalendarFinalRangeArray = this.heatmapCalendarFinalRangeArray;
		let params = new HttpParams({
			fromObject: {
				linkCode: this.linkcode,
			}
		})
		// console.log('this.heatMapCalendarSegementOverAll',this.heatMapCalendarSegementOverAll)
		this.accountService.getpnldatetransaction(params).subscribe({
			next: (data) => {
				if (data == 'too_many_attempts') {
					this.sweetAlertService.sweetAlert('error', 'You have exceeded the maximum number of allowed attempts. Please try again later.')
				}
				
				
				 const segmentKey = this.segments; // 'eq' or 'fno' or others
				const segmentData = data?.pnl?.[0]?.[0]?.[segmentKey] || [];
				this.heatMapCalendarSegementOverAll = data?.pnl?.[0]?.[segmentKey];
				this.fullPnlData=data?.pnl?.[0];
				console.log('segmentData', data.pnl[0]);
				this.renderCalendar(this.fromDate, this.toDate);
				// console.log('pnl='+JSON.stringify(this.heatMapCalendarSegementOverAll));

				// this.heatMapCalendarSegementOverAll = (data.pnl[0][0].eq)
				let from = this.profitLossForm.get('startDate');
				let to = this.profitLossForm.get('endDate');
				this.selectedStartDate = from;
				this.selectedEndDate = to;
				// console.log('selectedEndDate'+this.selectedEndDate.value );

				// this.heatmapCalendarFinalArray.forEach((day) => {
				// 	this.heatmapCalendarFinalRangeArray.forEach((day) => {

				// 	this.heatMapCalendarSegementOverAll.forEach((val: any) => {
				// 	  let dateFormat = new Date(formatDate(day.date, 'yyyy-MM-dd', 'en-US')).getTime();
				// 	  let dateFormatNew = new Date(formatDate(val.date, 'yyyy-MM-dd', 'en-US')).getTime();
				// 	  if (dateFormat == dateFormatNew) {
				// 		day['fill'] = val.color
				// 		day['pnl'] = `${val.pnl}`
				// 	}
				// 	// console.log('format'+dateFormat);
				// })
				if (this.heatMapCalendarSegementOverAll) {
					this.heatMapCalendarSegementOverAll.forEach((val: any) => {
						let dateFormat = new Date(formatDate(val.date, 'yyyy-MM-dd', 'en-US')).getTime();
						let dateFormatNew = new Date(formatDate(val.date, 'yyyy-MM-dd', 'en-US')).getTime();
						if (dateFormat == dateFormatNew) {
							val['fill'] = val.color;
							val['pnl'] = `${val.pnl}`;
						}
					});
				}
				// })

			}


		})
		// this.reportService.getHeatmapCalendarData(from, to, segment).subscribe({
		//   next: (data) => {
		// 	this.heatMapCalendarSegementOverAll = (data.equity != null) ? data.equity : [];

		// 	this.calendarYear.forEach((month) => {
		// 	  month.forEach((date: any) => {
		// 	    this.heatMapEquity.forEach((val: any) => {
		// 	      let dateFormat = new Date(formatDate(val.date, 'yyyy-MM-dd', 'en-US')).getTime();
		// 	      if (date[4] == dateFormat) {
		// 	        date[5] = `Gross Realised P&L: ${val.pnl}`
		// 	      }
		// 	    })
		// 	  })
		// 	})


		//   },
		//   error: (err) => {
		// 	console.log(err)
		//   }
		// })
	}

	getHeatMapCalendarRange() {
		this.renderCalendar(this.fromDate, this.toDate);
// 		this.filterHeatmapCalendarFinalRangeArray = this.heatmapCalendarFinalRangeArray;
// 		let from = this.profitLossForm.get('startDate');
// 		let to = this.profitLossForm.get('endDate');
// 		// let from = formatDate(this.profitLossForm.get('startDate').value, 'yyyy-MM-dd', 'en-US');
// 		// let to = formatDate(this.profitLossForm.get('endDate').value, 'yyyy-MM-dd', 'en-US');
// 		// let segment = this.profitLossForm.get('segment').value;
// 		let params = new HttpParams({
// 			fromObject: {
// 				linkCode: this.linkcode,
// 			}
// 		})
// this.accountService.getpnldatetransaction(params).subscribe({
// 				next: (data) => {
// 					if (data) {
// 						if (data == 'too_many_attempts') {
// 							this.sweetAlertService.sweetAlert('error', 'You have exceeded the maximum number of allowed attempts. Please try again later.')
// 						}
// 						this.heatMapCalendarSegement = (data.pnl[0][0].eq != null) ? data.pnl[0][0].eq : [];

//     const segmentKey = this.segments; // dynamic segment
//     const segmentData = data?.pnl?.[0]?.[0]?.[segmentKey] || [];

//     this.heatMapCalendarSegementOverAll = segmentData.map((val: any) => ({
//       date: val.date,
//       pnl: `${val.pnl}`,
//       color: val.color,
//       fill: val.color
//     }));

//     this.selectedStartDate = this.profitLossForm.get('startDate');
//     this.selectedEndDate = this.profitLossForm.get('endDate');

//     YearlyPNLCalendar.init({
//       element: '#calendar',
//       fromDate: this.selectedStartDate.value,
//       toDate: this.selectedEndDate.value,
//       data: this.heatMapCalendarSegementOverAll
//     });
  
// 		}
// 	},
// 	error: (err) => {
// 		//console.log(err);
// 		this.sweetAlertService.sweetAlert('', ' Link is expired')
// 	}
// })
}


		// if (this.profitLossForm.value.segment == 'eq') {
		// 	this.accountService.getpnldatetransaction(params).subscribe({
		// 		next: (data) => {
		// 			if (data) {
		// 				if (data == 'too_many_attempts') {
		// 					this.sweetAlertService.sweetAlert('error', 'You have exceeded the maximum number of allowed attempts. Please try again later.')
		// 				}
		// 				this.heatMapCalendarSegement = (data.pnl[0][0].eq != null) ? data.pnl[0][0].eq : [];
		// 				// console.log('heatMapCalendarSegement', this.heatMapCalendarSegement)
		// 				this.filterHeatmapCalendarFinalRangeArray.forEach((dayEquity) => {
		// 					this.heatMapCalendarSegement.forEach((val: any) => {
		// 						let dateFormat = new Date(formatDate(dayEquity.date, 'yyyy-MM-dd', 'en-US')).getTime();
		// 						let dateFormatNew = new Date(formatDate(val.date, 'yyyy-MM-dd', 'en-US')).getTime();
		// 						if (dateFormat == dateFormatNew) {
		// 							dayEquity['fill'] = val.color
		// 							dayEquity['pnl'] = `${val.pnl}`
		// 						}
		// 					})
		// 				})
		// 			}
		// 		},
		// 		error: (err) => {
		// 			//console.log(err);
		// 			this.sweetAlertService.sweetAlert('', ' Link is expired')
		// 		}
		// 	})
		// }
		// else if (this.profitLossForm.value.segment == 'fno') {
		// 	this.accountService.getpnldatetransaction(params).subscribe({
		// 		next: (data) => {
		// 			if (data) {
		// 				if (data == 'too_many_attempts') {
		// 					this.sweetAlertService.sweetAlert('error', 'You have exceeded the maximum number of allowed attempts. Please try again later.')
		// 				}
		// 				this.heatMapCalendarSegement = (data.pnl[0][1].fno != null) ? data.pnl[0][1].fno : [];
		// 				this.filterHeatmapCalendarFinalRangeArray.forEach((dayFno) => {
		// 					this.heatMapCalendarSegement.forEach((val: any) => {
		// 						let dateFormat = new Date(formatDate(dayFno.date, 'yyyy-MM-dd', 'en-US')).getTime();
		// 						let dateFormatNew = new Date(formatDate(val.date, 'yyyy-MM-dd', 'en-US')).getTime();
		// 						if (dateFormat == dateFormatNew) {
		// 							dayFno['fill'] = val.color
		// 							dayFno['pnl'] = `${val.pnl}`
		// 						}
		// 					})
		// 				})
		// 			}
		// 		},
		// 		error: (err) => {
		// 			//   console.log(err);
		// 			this.sweetAlertService.sweetAlert('', ' Link is expired')
		// 		}
		// 	})
		// }
		// else if (this.profitLossForm.value.segment == 'MCX') {
		//   this.reportService.getHeatmapCalendarData(from, to).subscribe({
		// 	next: (data) => {
		// 	  if (data) {
		// 		this.heatMapCalendarSegement = (data.mcx != null) ? data.mcx : [];
		// 		this.filterHeatmapCalendarFinalRangeArray.forEach((dayMcx) => {
		// 		  this.heatMapCalendarSegement.forEach((val: any) => {
		// 			let dateFormat = new Date(formatDate(dayMcx.date, 'yyyy-MM-dd', 'en-US')).getTime();
		// 			let dateFormatNew = new Date(formatDate(val.date, 'yyyy-MM-dd', 'en-US')).getTime();
		// 			if (dateFormat == dateFormatNew) {
		// 			  dayMcx['fill'] = val.color
		// 			  dayMcx['pnl'] = `${val.pnl}`
		// 			}
		// 		  })
		// 		})
		// 	  }
		// 	},
		// 	error: (err) => {
		// 	  console.log(err)
		// 	}
		//   })
		// }
		// else if (this.profitLossForm.value.segment == 'CD_NSE') {
		//   this.reportService.getHeatmapCalendarData(from, to, segment).subscribe({
		// 	next: (data) => {
		// 	  if (data) {
		// 		this.heatMapCalendarSegement = (data.cds != null) ? data.cds : [];
		// 		this.filterHeatmapCalendarFinalRangeArray.forEach((dayCds) => {
		// 		  this.heatMapCalendarSegement.forEach((val: any) => {
		// 			let dateFormat = new Date(formatDate(dayCds.date, 'yyyy-MM-dd', 'en-US')).getTime();
		// 			let dateFormatNew = new Date(formatDate(val.date, 'yyyy-MM-dd', 'en-US')).getTime();
		// 			if (dateFormat == dateFormatNew) {
		// 			  dayCds['fill'] = val.color
		// 			  dayCds['pnl'] = `${val.pnl}`
		// 			}
		// 		  })
		// 		})
		// 	  }
		// 	},
		// 	error: (err) => {
		// 	  console.log(err)
		// 	}
		//   })
		// }


	// }


	@ViewChild('searchInputA') searchInputA: ElementRef;
	@ViewChild('searchInputB') searchInputB: ElementRef;
	@ViewChild('searchInputC') searchInputC: ElementRef;
	@ViewChild('searchInputD') searchInputD: ElementRef;
	@ViewChild('searchInputE') searchInputE: ElementRef;

	clearSearchInputA() {
		if (this.searchInputA && this.searchInputA.nativeElement) {
			this.searchInputA.nativeElement.value = '';
		}
	}

	clearSearchInputB() {
		if (this.searchInputB && this.searchInputB.nativeElement) {
			this.searchInputB.nativeElement.value = '';
		}
	}

	clearSearchInputC() {
		if (this.searchInputC && this.searchInputC.nativeElement) {
			this.searchInputC.nativeElement.value = '';
		}
	}

	clearSearchInputD() {
		if (this.searchInputD && this.searchInputD.nativeElement) {
			this.searchInputD.nativeElement.value = '';
		}
	}

	clearSearchInputE() {
		if (this.searchInputE && this.searchInputE.nativeElement) {
			this.searchInputE.nativeElement.value = '';
		}
	}


	submitProfitNLoss(event?: any) {
		// if (this.anoSearchResults) {
		this.searchTextB = '';
		this.filteredEquityrow = [];
		this.anoSearchResults = false;
		this.acalculateVisiblePageNumbers();
		this.clearSearchInputA();
		//   }

		// if (this.noSearchResults) {
		this.searchTextB = '';
		this.filteredFnorow = [];
		this.noSearchResults = false;
		this.calculateVisiblePageNumbers();
		this.clearSearchInputB();
		//   }

		//   if (this.cnoSearchResults) {
		this.searchTextC = '';
		this.filteredcomrowData = [];
		this.cnoSearchResults = false;
		this.ccalculateVisiblePageNumbers();
		this.clearSearchInputC();
		//   }

		//   if (this.dnoSearchResults) {
		this.searchTextD = '';
		this.filteredcurrowData = [];
		this.dnoSearchResults = false;
		this.dcalculateVisiblePageNumbers();
		this.clearSearchInputD();
		//   }

		this.searchTextE = '';
		this.filterednsecomrowData = [];
		this.enoSearchResults = false;
		this.ecalculateVisiblePageNumbers();
		this.clearSearchInputE();


		// console.log(event);
		this.event = event;
		// console.log(this.event);
		const startDate = new Date(this.profitLossForm.value.startDate);
		const endDate = new Date(this.profitLossForm.value.endDate);
		// this.result = endDate.getFullYear() - startDate.getFullYear();
		this.profitLossForm.patchValue({ startDate: this.datefrom });
		this.profitLossForm.patchValue({ segment: event });
		// console.log('segment-'+this.profitLossForm.value.segment)



		const difference_In_Time = new Date(endDate).getTime() - new Date(startDate).getTime();
		const difference_In_Days = difference_In_Time / (1000 * 3600 * 24);
		if (difference_In_Days > 365) {
			this.sweetAlertService.sweetAlert('error', "Selected date should not be greater than one year");
			this.filterHeatMapCalendarRange();
			return;
		} else {
			//   this.profitNLosssApi();
			this.filterHeatMapCalendarRange();
		}
	}

	filterHeatMapCalendarRange() {
		this.loading = true;
		// this.clearPnlRecord();
		setTimeout(() => {
			this.getFilterHeatmapData();
		}, 1000);
	}

	getFilterHeatmapData() {
		this.loading = false;
		this.renderCalendar(this.fromDate, this.toDate);
		// let params = new HttpParams({
		// 	fromObject: {
		// 		linkCode: this.linkcode,
		// 	}
		// })
		// this.heatMapCalendarSegement = [];
		// this.filterHeatmapCalendarFinalRangeArray = [];
		// this.filterHeatmapCalendarFinalRangeArray = this.heatmapCalendarFinalRangeArray;
		// let from = formatDate(this.profitLossForm.get('startDate').value, 'yyyy-MM-dd', 'en-US');
		// let to = formatDate(this.profitLossForm.get('endDate').value, 'yyyy-MM-dd', 'en-US');
		// // let segment = this.profitLossForm.get('eq').value;
		// this.selectedStartDate = from;
		// this.selectedEndDate = to;
		// this.hideHeatmap = false;
		// if (this.profitLossForm.value.segment == this.segments[0]) {
		// 	this.accountService.getpnldatetransaction(params).subscribe({
		// 		next: (data) => {
		// 			this.loading = false;
		// 			if (data) {
		// 				if (data == 'too_many_attempts') {
		// 					this.sweetAlertService.sweetAlert('error', 'You have exceeded the maximum number of allowed attempts. Please try again later.')
		// 				}
		// 				// this.heatMapCalendarSegement = (data.pnl[0][0].this.profitLossForm.value.segment != null) ? data.pnl[0][0].this.profitLossForm.value.segment : [];
		// 				console.log(this.heatMapCalendarSegement)
		// 				if (this.profitLossForm.value.segment == 'eq') {
		// 					this.heatMapCalendarSegement = (data.pnl[0][0].eq != null) ? data.pnl[0][0].eq : [];
		// 				}
		// 				else if (this.profitLossForm.value.segment == 'fno') {
		// 					this.heatMapCalendarSegement = (data.pnl[0][0].fno != null) ? data.pnl[0][0].fno : [];
		// 				}
		// 				else if (this.profitLossForm.value.segment == 'mcx') {
		// 					this.heatMapCalendarSegement = (data.pnl[0][0].mcx != null) ? data.pnl[0][0].mcx : [];
		// 				}
		// 				else if (this.profitLossForm.value.segment == 'cds') {
		// 					this.heatMapCalendarSegement = (data.pnl[0][0].cds != null) ? data.pnl[0][0].cds : [];
		// 				}
		// 				else if (this.profitLossForm.value.segment == ' nse_com') {
		// 					this.heatMapCalendarSegement = (data.pnl[0][0].nse_com != null) ? data.pnl[0][0].nse_com : [];
		// 				}
        //                this.renderCalendar(this.fromDate, this.toDate);

		// 				this.filterHeatmapCalendarFinalRangeArray.forEach((dayEquity) => {
		// 					this.heatMapCalendarSegement.forEach((val: any) => {
		// 						let dateFormat = new Date(formatDate(dayEquity.date, 'yyyy-MM-dd', 'en-US')).getTime();
		// 						let dateFormatNew = new Date(formatDate(val.date, 'yyyy-MM-dd', 'en-US')).getTime();
		// 						if (dateFormat == dateFormatNew) {
		// 							dayEquity['fill'] = val.color
		// 							dayEquity['pnl'] = `${val.pnl}`
		// 						}
		// 					})
		// 				})
		// 			}
		// 		},
		// 		error: () => {
		// 			this.loading = false;
		// 			this.sweetAlertService.sweetAlert('', ' Link is expired')
		// 		}
		// 	})
		// }
		// if (this.profitLossForm.value.segment == this.segments[1]) {
		// 	this.accountService.getpnldatetransaction(params).subscribe({
		// 		next: (data) => {

		// 			this.loading = false;
		// 			if (data) {
		// 				if (data == 'too_many_attempts') {
		// 					this.sweetAlertService.sweetAlert('error', 'You have exceeded the maximum number of allowed attempts. Please try again later.')
		// 				}
		// 				if (this.profitLossForm.value.segment == 'eq') {
		// 					this.heatMapCalendarSegement = (data.pnl[0][1].eq != null) ? data.pnl[0][1].eq : [];
		// 				}
		// 				else if (this.profitLossForm.value.segment == 'fno') {
		// 					this.heatMapCalendarSegement = (data.pnl[0][1].fno != null) ? data.pnl[0][1].fno : [];
		// 				}
		// 				else if (this.profitLossForm.value.segment == 'mcx') {
		// 					this.heatMapCalendarSegement = (data.pnl[0][1].mcx != null) ? data.pnl[0][1].mcx : [];
		// 				}
		// 				else if (this.profitLossForm.value.segment == 'cds') {
		// 					this.heatMapCalendarSegement = (data.pnl[0][1].cds != null) ? data.pnl[0][1].cds : [];
		// 				}
		// 				else if (this.profitLossForm.value.segment == ' nse_com') {
		// 					this.heatMapCalendarSegement = (data.pnl[0][1].nse_com != null) ? data.pnl[0][1].nse_com : [];
		// 				}
		// 				// console.log('heatMapCalendarSegement', this.heatMapCalendarSegement)
		// 				this.renderCalendar(this.fromDate, this.toDate);
		// 				this.filterHeatmapCalendarFinalRangeArray.forEach((dayEquity) => {
		// 					this.heatMapCalendarSegement.forEach((val: any) => {
		// 						let dateFormat = new Date(formatDate(dayEquity.date, 'yyyy-MM-dd', 'en-US')).getTime();
		// 						let dateFormatNew = new Date(formatDate(val.date, 'yyyy-MM-dd', 'en-US')).getTime();
		// 						if (dateFormat == dateFormatNew) {
		// 							dayEquity['fill'] = val.color
		// 							dayEquity['pnl'] = `${val.pnl}`
		// 						}
		// 					})
		// 				})
		// 			}
		// 		},
		// 		error: (err) => {
		// 			if (err) {
		// 				this.sweetAlertService.sweetAlert('', ' Link is expired')
		// 			}
		// 			this.loading = false;
		// 		}
		// 	})
		// }
		// if (this.profitLossForm.value.segment == this.segments[2]) {
		// 	this.accountService.getpnldatetransaction(params).subscribe({
		// 		next: (data) => {

		// 			this.loading = false;
		// 			if (data) {
		// 				if (data == 'too_many_attempts') {
		// 					this.sweetAlertService.sweetAlert('error', 'You have exceeded the maximum number of allowed attempts. Please try again later.')
		// 				}
		// 				// this.heatMapCalendarSegement = (data.pnl[0][2].this.profitLossForm.value.segment != null) ? data.pnl[0][2].this.profitLossForm.value.segment : [];
		// 				if (this.profitLossForm.value.segment == 'eq') {
		// 					this.heatMapCalendarSegement = (data.pnl[0][2].eq != null) ? data.pnl[0][2].eq : [];
		// 				}
		// 				else if (this.profitLossForm.value.segment == 'fno') {
		// 					this.heatMapCalendarSegement = (data.pnl[0][2].fno != null) ? data.pnl[0][2].fno : [];
		// 				}
		// 				else if (this.profitLossForm.value.segment == 'mcx') {
		// 					this.heatMapCalendarSegement = (data.pnl[0][2].mcx != null) ? data.pnl[0][2].mcx : [];
		// 				}
		// 				else if (this.profitLossForm.value.segment == 'cds') {
		// 					this.heatMapCalendarSegement = (data.pnl[0][2].cds != null) ? data.pnl[0][2].cds : [];
		// 				}
		// 				else if (this.profitLossForm.value.segment == ' nse_com') {
		// 					this.heatMapCalendarSegement = (data.pnl[0][2].nse_com != null) ? data.pnl[0][2].nse_com : [];
		// 				}
		// 				this.renderCalendar(this.fromDate, this.toDate);
		// 				this.filterHeatmapCalendarFinalRangeArray.forEach((dayEquity) => {
		// 					this.heatMapCalendarSegement.forEach((val: any) => {
		// 						let dateFormat = new Date(formatDate(dayEquity.date, 'yyyy-MM-dd', 'en-US')).getTime();
		// 						let dateFormatNew = new Date(formatDate(val.date, 'yyyy-MM-dd', 'en-US')).getTime();
		// 						if (dateFormat == dateFormatNew) {
		// 							dayEquity['fill'] = val.color
		// 							dayEquity['pnl'] = `${val.pnl}`
		// 						}
		// 					})
		// 				})
		// 			}
		// 		},
		// 		error: (err) => {
		// 			if (err) {
		// 				this.sweetAlertService.sweetAlert('', ' Link is expired')
		// 			}
		// 			this.loading = false;
		// 		}
		// 	})
		// }
		// if (this.profitLossForm.value.segment == this.segments[3]) {
		// 	this.accountService.getpnldatetransaction(params).subscribe({
		// 		next: (data) => {

		// 			this.loading = false;
		// 			if (data) {
		// 				if (data == 'too_many_attempts') {
		// 					this.sweetAlertService.sweetAlert('error', 'You have exceeded the maximum number of allowed attempts. Please try again later.')
		// 				}
		// 				if (this.profitLossForm.value.segment == 'eq') {
		// 					this.heatMapCalendarSegement = (data.pnl[0][3].eq != null) ? data.pnl[0][3].eq : [];
		// 				}
		// 				else if (this.profitLossForm.value.segment == 'fno') {
		// 					this.heatMapCalendarSegement = (data.pnl[0][3].fno != null) ? data.pnl[0][3].fno : [];
		// 				}
		// 				else if (this.profitLossForm.value.segment == 'mcx') {
		// 					this.heatMapCalendarSegement = (data.pnl[0][3].mcx != null) ? data.pnl[0][3].mcx : [];
		// 				}
		// 				else if (this.profitLossForm.value.segment == 'cds') {
		// 					this.heatMapCalendarSegement = (data.pnl[0][3].cds != null) ? data.pnl[0][3].cds : [];
		// 				}
		// 				else if (this.profitLossForm.value.segment == ' nse_com') {
		// 					this.heatMapCalendarSegement = (data.pnl[0][3].nse_com != null) ? data.pnl[0][3].nse_com : [];
		// 				}
		// 				this.renderCalendar(this.fromDate, this.toDate);
		// 				// this.heatMapCalendarSegement = (data.pnl[0][3].this.profitLossForm.value.segment != null) ? data.pnl[0][3].this.profitLossForm.value.segment : [];
		// 				this.filterHeatmapCalendarFinalRangeArray.forEach((dayEquity) => {
		// 					this.heatMapCalendarSegement.forEach((val: any) => {
		// 						let dateFormat = new Date(formatDate(dayEquity.date, 'yyyy-MM-dd', 'en-US')).getTime();
		// 						let dateFormatNew = new Date(formatDate(val.date, 'yyyy-MM-dd', 'en-US')).getTime();
		// 						if (dateFormat == dateFormatNew) {
		// 							dayEquity['fill'] = val.color
		// 							dayEquity['pnl'] = `${val.pnl}`
		// 						}
		// 					})
		// 				})
		// 			}
		// 		},
		// 		error: (err) => {
		// 			if (err) {
		// 				this.sweetAlertService.sweetAlert('', ' Link is expired')
		// 			}
		// 			this.loading = false;
		// 		}
		// 	})
		// }
		// if (this.profitLossForm.value.segment == this.segments[4]) {
		// 	this.accountService.getpnldatetransaction(params).subscribe({
		// 		next: (data) => {

		// 			this.loading = false;
		// 			if (data) {
		// 				if (data == 'too_many_attempts') {
		// 					this.sweetAlertService.sweetAlert('error', 'You have exceeded the maximum number of allowed attempts. Please try again later.')
		// 				}
		// 				if (this.profitLossForm.value.segment == 'eq') {
		// 					this.heatMapCalendarSegement = (data.pnl[0][4].eq != null) ? data.pnl[0][4].eq : [];
		// 				}
		// 				else if (this.profitLossForm.value.segment == 'fno') {
		// 					this.heatMapCalendarSegement = (data.pnl[0][4].fno != null) ? data.pnl[0][4].fno : [];
		// 				}
		// 				else if (this.profitLossForm.value.segment == 'mcx') {
		// 					this.heatMapCalendarSegement = (data.pnl[0][4].mcx != null) ? data.pnl[0][4].mcx : [];
		// 				}
		// 				else if (this.profitLossForm.value.segment == 'cds') {
		// 					this.heatMapCalendarSegement = (data.pnl[0][4].cds != null) ? data.pnl[0][4].cds : [];
		// 				}
		// 				else if (this.profitLossForm.value.segment == ' nse_com') {
		// 					this.heatMapCalendarSegement = (data.pnl[0][4].nse_com != null) ? data.pnl[0][4].nse_com : [];
		// 				}
		// 				this.renderCalendar(this.fromDate, this.toDate);
		// 				// this.heatMapCalendarSegement = (data.pnl[0][3].this.profitLossForm.value.segment != null) ? data.pnl[0][3].this.profitLossForm.value.segment : [];
		// 				this.filterHeatmapCalendarFinalRangeArray.forEach((dayEquity) => {
		// 					this.heatMapCalendarSegement.forEach((val: any) => {
		// 						let dateFormat = new Date(formatDate(dayEquity.date, 'yyyy-MM-dd', 'en-US')).getTime();
		// 						let dateFormatNew = new Date(formatDate(val.date, 'yyyy-MM-dd', 'en-US')).getTime();
		// 						if (dateFormat == dateFormatNew) {
		// 							dayEquity['fill'] = val.color
		// 							dayEquity['pnl'] = `${val.pnl}`
		// 						}
		// 					})
		// 				})
		// 			}
		// 		},
		// 		error: (err) => {
		// 			if (err) {
		// 				this.sweetAlertService.sweetAlert('', ' Link is expired')
		// 			}
		// 			this.loading = false;
		// 		}
		// 	})
		// }
	}

	selectStartDate() {
		if (this.profitLossForm.get('endDate').value == undefined) return;
		let startTimeflag = compareDates(this.profitLossForm.get('startDate').value, this.profitLossForm.get('endDate').value, '>=');
		if (startTimeflag) {
			this.profitLossForm.controls['startDate'].setErrors({ required: null });
			this.profitLossForm.controls['startDate'].updateValueAndValidity();
		} else {
			this.profitLossForm.controls['startDate'].setErrors({ required: true });
			return;
		}
	}

	selectEndDate() {
		if (this.profitLossForm.get('endDate').value == undefined) return;
		let endTimeflag = compareDates(this.profitLossForm.get('startDate').value, this.profitLossForm.get('endDate').value, '>=');
		if (endTimeflag) {
			this.profitLossForm.controls['endDate'].setErrors({ required: null });
			this.profitLossForm.controls['endDate'].updateValueAndValidity();
		} else {
			this.profitLossForm.controls['endDate'].setErrors({ required: true });
			return;
		}
	}



	mouseEnter(trigger: any, event: any, pnl: any) {
		this.tooltipDate = formatDate(event, 'MMM dd, yyyy', 'en-US');
		this.eventPnl = pnl;
		trigger.open();
	}

	mouseLeave(trigger: any) {
		trigger.close();
	}

	clickEvent(event: any) {
		if (event?.pnl) {
			this.getEventTradeByDate(event);
		}
	}

	getEventTradeByDate(dateFormat: any) {
		this.loading = true;
		const formData: any = new FormData();
		formData.append('trade_date', formatDate(dateFormat.date, 'yyyy-MM-dd', 'en-US'))
		// this.reportService.getEventTradeData(formData).subscribe({
		//   next: (data) => {
		// 	this.loading = false;
		// 	if (data) {
		// 	//   this.openTradeDateEvent(data);
		// 	} else {
		// 	  this.sweetAlertService.sweetAlert("error", "Data not available")
		// 	}
		//   },
		//   error: () => {
		// 	this.loading = false;
		//   }
		// })
	}

	//   openTradeDateEvent(eventData: any) {
	// 	const dialogRef: NgbModalRef = this.modalService.open(TradeDateComponent, { centered: true, size: 'lg' });
	// 	dialogRef.componentInstance.data = eventData
	//   }

	//   open(content) {
	// 	this.modalService.open(content, { centered: true, size: 'md', scrollable: true })
	//   }


	// tab  api
	getpnldatewise() {
		let params = new HttpParams({
			fromObject: {
				linkCode: this.linkcode,
			}
		})
		this.accountService.getPnltransaction(params).subscribe({
			next: (data) => {
				if (data == 'no data found') {
					this.datapresent = false;
				}
				else if (data == 'too_many_attempts') {
					this.datapresent = false;
					this.sweetAlertService.sweetAlert('error', 'You have exceeded the maximum number of allowed attempts. Please try again later');
				}

				else {
					this.datapresent = true;

				
					// this.equitydata = data.sheets[0]?.blocks[0];
					// this.equitytable = data.sheets[0]?.blocks[0]?.pnl;
					// this.equityname = data.sheets[0]?. blocks[0]?.name;
					// this.fnotable = data.sheets[0].blocks[1]?.pnl;
					// this.fno = data.sheets[0]?.blocks[1];
					// this.fnoname = data.sheets[0]?.blocks[1]?.name;
					// this.clientdeatils = data.sheets[0].details;
					// this.objectArray = this.clientdeatils.client_name;
					// this.datefrom = this.clientdeatils.date_from;
					// this.dateto = this.clientdeatils.date_to;
					// this.datetype= this.clientdeatils.date_type;
					// this.startDate = this.clientdeatils.date_from; 
					// this.endDate= this.clientdeatils.date_to;
					// let segment = JSON.parse(this.clientdeatils.segments);
					// this.equityheader = data.sheets[0].blocks[0]?.header;
					// this.equityrow = data.sheets[0].blocks[0]?.rows;
					// this.fnoheader = data.sheets[0].blocks[1]?.header;
					// this.fnorow = data.sheets[0].blocks[1]?.rows;
					// console.log(data);
					this.equitydata = data.sheets[0].blocks[0];
					this.equitytable = data.sheets[0].blocks[0]?.pnl;
					this.equityname = data.sheets[0].blocks[0]?.name;
					this.fnotable = data.sheets[0].blocks[1]?.pnl;
					this.fno = data.sheets[0].blocks[1];
					this.fnoname = data.sheets[0].blocks[1]?.name;
					this.fnotable = data.sheets[0].blocks[1]?.pnl;
					this.clientdeatils = data.sheets[0].details;
					this.equityheader = data.sheets[0].blocks[0]?.header;


					//	this.equityrow = data.sheets[0].blocks[0]?.rows;
					this.originalEquityrow = data.sheets[0].blocks[0]?.rows;
					this.equityrow = this.originalEquityrow;

					// // calendar date range
					this.fromDate = this.clientdeatils.date_from;
					this.toDate   = this.clientdeatils.date_to;
					setTimeout(() => {
						 this.renderCalendar(this.fromDate, this.toDate);
					});

					// // build calendar pnl data
					// this.pnlData = this.originalEquityrow.map((row: any) => ({
					// 	date: row.trade_date + ' 00:00:00', // adjust key if needed
					// 	pnl: Number(row.pnl),
					// }));



					this.fnoheader = data.sheets[0].blocks[1]?.header;
					this.fnorow = data.sheets[0].blocks[1]?.rows;

					this.originalFnorow = data.sheets[0].blocks[1]?.rows;
					this.fnorow = this.originalFnorow;

					this.com = data.sheets[0].blocks[2];
					this.comheader = data.sheets[0].blocks[2]?.header;

					//this.comrow = data.sheets[0].blocks[2]?.rows;
					this.originalComrow = data.sheets[0].blocks[2]?.rows;
					this.comrow = this.originalComrow;

					this.comname = data.sheets[0].blocks[2]?.name;
					this.comtable = data.sheets[0].blocks[2]?.pnl;
					this.cur = data.sheets[0].blocks[3];
					this.curheader = data.sheets[0].blocks[3]?.header;
					this.nse = data.sheets[0].blocks[4];
					this.nseheader = data.sheets[0].blocks[4]?.header;

					//this.currow = data.sheets[0].blocks[3]?.rows;
					this.originalCurrow = data.sheets[0].blocks[3]?.rows;
					this.originalNserow = data.sheets[0].blocks[4]?.rows;
					this.currow = this.originalCurrow;
					this.nserow = this.originalNserow;

					// if (this.equityrow.length < 0) {
					// 	this.showSearchA = false;
					// }

					this.curname = data.sheets[0].blocks[3]?.name;
					this.curtable = data.sheets[0].blocks[3]?.pnl;
					this.nsename = data.sheets[0].blocks[4]?.name;
					this.nsetable = data.sheets[0].blocks[4]?.pnl;
					this.nametype = this.clientdeatils.name_type;
					this.enabled = this.clientdeatils.enable_page;
					this.objectArray = this.clientdeatils.client_name;
					this.datefrom = this.clientdeatils.date_from;
					this.dateto = this.clientdeatils.date_to;
					this.datetype = this.clientdeatils.date_type;
					this.startDate = this.clientdeatils.date_from;
					this.endDate = this.clientdeatils.date_to;
					this.displayTrades = this.clientdeatils.display_trades;
					// console.log(this.displayTrades)
					let segment = JSON.parse(this.clientdeatils.segments);
					if (this.equityname === 'Commodity') {
						this.equityname = 'MCX';
					} else if (this.fnoname === 'Commodity') {
						this.fnoname = 'MCX';
					} else if (this.comname === 'Commodity') {
						this.comname = 'MCX';
					} else if (this.curname === 'Commodity') {
						this.curname = 'MCX';
					}
					else if (this.nsename === 'Commodity') {
						this.nsename = 'MCX';
					}

					if (this.nametype == 'masked') {
						this.maskname = this.clientdeatils.client_name.slice(4).replace(/./g, '*');;
					}
					else {
						this.objectArray = this.clientdeatils.client_name;
					}
					// if(segment.length > 1) {
					// 	this.segments = segment.split(',');
					// }
					if (Array.isArray(segment)) {
						// Check if 'segment' is an array
						this.segments = segment;
						const desiredOrder: string[] = ["eq", "fno", "mcx","nse_com", "cds"];

						// Sort the items array based on the desired order
						this.segments.sort((a, b) => {
							return desiredOrder.indexOf(a) - desiredOrder.indexOf(b);
						});
					}
					else {
						this.segments = segment;
					}
					this.profitLossForm.patchValue({ startDate: this.datefrom });
					this.profitLossForm.patchValue({ endDate: this.dateto });
					this.submitProfitNLoss(this.segments[0]);

				}
			},
			error: (err) => {
				this.sweetAlertService.sweetAlert('error', 'Link is expired');
				this.loading = false;
				this.dataNotFound = true;
			}
		})
	}

	searchA(event: any) {
		const searchText = event.target.value;
		let enterClientID = searchText;
		this.equityrow = this.equityrow.filter((element: any) => {
			const text = searchText.toLowerCase();
			return element[0].toLowerCase().includes(text);
		});
	}

	searchD(event: any) {
		const searchText = event.target.value;
		let enterClientID = searchText;
		this.currow = this.currow.filter((element: any) => {
			const text = searchText.toLowerCase();
			return element[0].toLowerCase().includes(text);
		});
	}



	getNumber(returns: any) {
		return Number(returns).toFixed(2);
	}

	getheader(str: any) {
		// return str.replace(/_(.)/g, (_, firstLetter) => firstLetter.toUpperCase());
		// return stringWithoutUnderscores.replace(/_/g, ' ');
		return str.replace(/_/g, ' ');
		// return stringWithoutUnderscores;
	}



	// pnl api

	// getpnldata() {
	// 	let params = new HttpParams({
	// 		fromObject:{
	// 			linkCode:this.linkcode,
	// 		}
	// 	})
	// 	this.accountService.getpnldatetransaction(params).subscribe({
	// 		next:(data)=>{
	// 			console.log(data);
	// 			this.pnldata = data;
	// 			// console.log('pnl'+data)
	// 		}
	// 	})
	// }





	// Equity 

	// search
	// searchTextA: string = '';

	// applyFilterA(event: any) {
	// 	const searchInputA = event.target.value.toLowerCase();
	// 	this.searchTextA = searchInputA;
	// 	if (searchInputA === '') {
	// 		this.equityrow = this.originalEquityrow;
	// 	} else {
	// 		this.equityrow = this.originalEquityrow.filter((element: any) => {
	// 			const nameA = element[0].toLowerCase();
	// 			return nameA.includes(searchInputA);
	// 		});
	// 	}
	// }

	searchTextA: string = '';
	filteredEquityrow: any[] = [];


	anoSearchResults: boolean = false;

	applyFilterA(event: any) {
		const searchText = event.target.value.toLowerCase();
		this.searchTextB = searchText;

		if (searchText === '') {
			this.filteredEquityrow = [];
			this.anoSearchResults = false;
		} else {
			this.filteredEquityrow = this.originalEquityrow.filter((element: any) => {
				const name = element[0].toLowerCase();
				return name.includes(searchText);
			});
			this.acurrentPagee = 1;
			this.anoSearchResults = this.filteredEquityrow.length === 0;
		}
		this.acalculateVisiblePageNumbers();
	}



	acalculateVisiblePageNumbers() {
		if (this.filteredEquityrow.length === 0) {
			const totalVisiblePages = 3;
			const middlePage = Math.ceil(totalVisiblePages / 2);
			const firstPage = Math.max(1, this.acurrentPagee - middlePage + 1);
			const lastPage = Math.min(this.atotalPages, firstPage + totalVisiblePages - 1);
			this.avisiblePageNumbers.splice(0, this.avisiblePageNumbers.length); // Clear the array
			this.avisiblePageNumbers.push(...Array(lastPage - firstPage + 1).fill(0).map((_, index) => firstPage + index));
		} else {
			this.avisiblePageNumbers.splice(0, this.avisiblePageNumbers.length);
		}
	}



	// pagination 

	acurrentPagee = 1;
	aitemsPerPage = 20;

	// get atotalPages(): number {
	// 	return Math.ceil(this.equityrow.length / this.aitemsPerPage);
	// }

	get atotalPages(): number {
		if (this.searchTextA === '') {
			return Math.ceil(this.equityrow.length / this.aitemsPerPage);
		} else {
			return Math.ceil(this.filteredEquityrow.length / this.aitemsPerPage);
		}
	}

	get apageNumbers(): number[] {
		return Array(this.atotalPages).fill(0).map((_, index) => index + 1);
	}

	// get equityrowData(): any[] {
	// 	const astartIndex = (this.acurrentPagee - 1) * this.aitemsPerPage;
	// 	return this.equityrow.slice(astartIndex, astartIndex + this.aitemsPerPage);
	// }

	get equityrowData(): any[] {
		if (this.searchTextB === '') {
			// If the search field is empty, show all rows
			const startIndex = (this.acurrentPagee - 1) * this.aitemsPerPage;
			return this.equityrow.slice(startIndex, startIndex + this.aitemsPerPage);
		} else {
			// If there is a search, show the filtered data
			const startIndex = (this.acurrentPagee - 1) * this.aitemsPerPage;
			return this.filteredEquityrow.slice(startIndex, startIndex + this.aitemsPerPage);
		}
	}

	get avisiblePageNumbers(): number[] {
		const avisibleData = this.equityrow.filter(data => data.visible);
		const atotalVisiblePages = 3;
		const amiddlePage = Math.ceil(atotalVisiblePages / 2);
		const afirstPage = Math.max(1, this.acurrentPagee - amiddlePage + 1);
		const alastPage = Math.min(this.atotalPages, afirstPage + atotalVisiblePages - 1);
		return Array(alastPage - afirstPage + 1).fill(0).map((_, index) => afirstPage + index);
	}

	achangePagep(page: number): void {
		if (page === -1 && this.acurrentPagee > 1) {
			this.acurrentPagee--;
		}
	}

	achangePage(page: number): void {
		if (page > 0 && page <= this.atotalPages) {
			this.acurrentPagee = page;
		}
	}

	achangePagen(page: number): void {
		if (page === 1 && this.acurrentPagee < this.atotalPages) {
			this.acurrentPagee++;
		}
	}


	// Futures & Options

	// search

	searchTextB: string = '';
	filteredFnorow: any[] = [];


	noSearchResults: boolean = false;

	applyFilterB(event: any) {
		const searchText = event.target.value.toLowerCase();
		this.searchTextB = searchText;

		if (searchText === '') {
			this.filteredFnorow = [];
			this.noSearchResults = false;
		} else {
			this.filteredFnorow = this.originalFnorow.filter((element: any) => {
				const name = element[0].toLowerCase();
				return name.includes(searchText);
			});
			this.currentPagee = 1;
			this.noSearchResults = this.filteredFnorow.length === 0;
		}
		this.calculateVisiblePageNumbers();
	}



	calculateVisiblePageNumbers() {
		if (this.filteredFnorow.length === 0) {
			const totalVisiblePages = 3;
			const middlePage = Math.ceil(totalVisiblePages / 2);
			const firstPage = Math.max(1, this.currentPagee - middlePage + 1);
			const lastPage = Math.min(this.totalPages, firstPage + totalVisiblePages - 1);
			this.visiblePageNumbers.splice(0, this.visiblePageNumbers.length); // Clear the array
			this.visiblePageNumbers.push(...Array(lastPage - firstPage + 1).fill(0).map((_, index) => firstPage + index));
		} else {
			this.visiblePageNumbers.splice(0, this.visiblePageNumbers.length);
		}
	}


	// pagination

	currentPagee = 1;
	itemsPerPage = 20;

	// get totalPages(): number {
	// 	return Math.ceil(this.fnorow.length / this.itemsPerPage);
	// }

	// get totalPages(): number {
	// 	if (this.searchTextB === '') {
	// 		return Math.ceil(this.fnorow.length / this.itemsPerPage);
	// 	} else {
	// 		return Math.ceil(this.filteredFnorow.length / this.itemsPerPage);
	// 	}
	// }

	get totalPages(): number {
		if (this.searchTextB === '') {
			return this.fnorow ? Math.ceil(this.fnorow.length / this.itemsPerPage) : 0;
		} else {
			return this.filteredFnorow ? Math.ceil(this.filteredFnorow.length / this.itemsPerPage) : 0;
		}
	}
	


	get pageNumbers(): number[] {
		return Array(this.totalPages).fill(0).map((_, index) => index + 1);
	}

	get fnorowData(): any[] {
		if (this.searchTextB === '') {
			// If the search field is empty, show all rows
			const startIndex = (this.currentPagee - 1) * this.itemsPerPage;
			return this.fnorow.slice(startIndex, startIndex + this.itemsPerPage);
		} else {
			// If there is a search, show the filtered data
			const startIndex = (this.currentPagee - 1) * this.itemsPerPage;
			return this.filteredFnorow.slice(startIndex, startIndex + this.itemsPerPage);
		}
	}
	


	// get fnorowData(): any[] {
	// 	if (this.filteredFnorow.length === 0) {
	// 		const startIndex = (this.currentPagee - 1) * this.itemsPerPage;
	// 		return this.fnorow.slice(startIndex, startIndex + this.itemsPerPage);
	// 	} else if (this.searchTextB === '') {
	// 		// If the search field is empty, show all rows
	// 		const startIndex = (this.currentPagee - 1) * this.itemsPerPage;
	// 		return this.fnorow.slice(startIndex, startIndex + this.itemsPerPage);
	// 	  }
	// 	  else{
	// 		const startIndex = (this.currentPagee - 1) * this.itemsPerPage;
	// 		return this.filteredFnorow.slice(startIndex, startIndex + this.itemsPerPage);
	// 	}
	// }

	// get visiblePageNumbers(): number[] {
	// 	const visibleData = this.fnorow.filter(data => data.visible);
	// 	const totalVisiblePages = 3;
	// 	const middlePage = Math.ceil(totalVisiblePages / 2);
	// 	const firstPage = Math.max(1, this.currentPagee - middlePage + 1);
	// 	const lastPage = Math.min(this.totalPages, firstPage + totalVisiblePages - 1);
	// 	return Array(lastPage - firstPage + 1).fill(0).map((_, index) => firstPage + index);
	// }

	get visiblePageNumbers(): number[] {
		if (!this.fnorow) {
			return [];
		}
	
		const visibleData = this.fnorow.filter(data => data.visible);
		const totalVisiblePages = 3;
		const middlePage = Math.ceil(totalVisiblePages / 2);
		const firstPage = Math.max(1, this.currentPagee - middlePage + 1);
		const lastPage = Math.min(this.totalPages, firstPage + totalVisiblePages - 1);
		return Array(lastPage - firstPage + 1).fill(0).map((_, index) => firstPage + index);
	}
	

	changePagep(page: number): void {
		if (page === -1 && this.currentPagee > 1) {
			this.currentPagee--;
		}
	}

	changePage(page: number): void {
		if (page > 0 && page <= this.totalPages) {
			this.currentPagee = page;
		}
	}

	changePagen(page: number): void {
		if (page === 1 && this.currentPagee < this.totalPages) {
			this.currentPagee++;
		}
	}



	// MCX

	// search

	searchTextC: string = '';
	filteredcomrowData: any[] = [];


	cnoSearchResults: boolean = false;

	applyFilterC(event: any) {
		const searchText = event.target.value.toLowerCase();
		this.searchTextC = searchText;

		if (searchText === '') {
			this.filteredcomrowData = [];
			this.cnoSearchResults = false;
		} else {
			this.filteredcomrowData = this.originalComrow.filter((element: any) => {
				const name = element[0].toLowerCase();
				return name.includes(searchText);
			});
			this.bcurrentPagee = 1;
			this.cnoSearchResults = this.filteredcomrowData.length === 0;
		}
		this.ccalculateVisiblePageNumbers();
	}



	ccalculateVisiblePageNumbers() {
		if (this.filteredcomrowData.length === 0) {
			const totalVisiblePages = 3;
			const middlePage = Math.ceil(totalVisiblePages / 2);
			const firstPage = Math.max(1, this.bcurrentPagee - middlePage + 1);
			const lastPage = Math.min(this.btotalPages, firstPage + totalVisiblePages - 1);
			this.bvisiblePageNumbers.splice(0, this.bvisiblePageNumbers.length); // Clear the array
			this.bvisiblePageNumbers.push(...Array(lastPage - firstPage + 1).fill(0).map((_, index) => firstPage + index));
		} else {
			this.bvisiblePageNumbers.splice(0, this.bvisiblePageNumbers.length);
		}
	}


	// pagination


	bcurrentPagee = 1;
	bitemsPerPage = 20;

	// get btotalPages(): number {
	// 	return Math.ceil(this.comrow.length / this.bitemsPerPage);
	// }

	// get btotalPages(): number {
	// 	if (this.searchTextC === '') {
	// 		return Math.ceil(this.comrow.length / this.bitemsPerPage);
	// 	} else {
	// 		return Math.ceil(this.filteredcomrowData.length / this.bitemsPerPage);
	// 	}
	// }

	get btotalPages(): number {
		if (this.searchTextC === '') {
			return this.comrow ? Math.ceil(this.comrow.length / this.bitemsPerPage) : 0;
		} else {
			return this.filteredcomrowData ? Math.ceil(this.filteredcomrowData.length / this.bitemsPerPage) : 0;
		}
	}
	

	get bpageNumbers(): number[] {
		return Array(this.btotalPages).fill(0).map((_, index) => index + 1);
	}

	get comrowData(): any[] {
		if (this.filteredcomrowData.length === 0) {
			const startIndex = (this.bcurrentPagee - 1) * this.bitemsPerPage;
			return this.comrow.slice(startIndex, startIndex + this.bitemsPerPage);
		} else {
			const startIndex = (this.bcurrentPagee - 1) * this.bitemsPerPage;
			return this.filteredcomrowData.slice(startIndex, startIndex + this.bitemsPerPage);
		}
	}

	// get bvisiblePageNumbers(): number[] {
	// 	const bvisibleData = this.comrow.filter(data => data.visible);
	// 	const btotalVisiblePages = 3;
	// 	const bmiddlePage = Math.ceil(btotalVisiblePages / 2);
	// 	const bfirstPage = Math.max(1, this.bcurrentPagee - bmiddlePage + 1);
	// 	const blastPage = Math.min(this.btotalPages, bfirstPage + btotalVisiblePages - 1);
	// 	return Array(blastPage - bfirstPage + 1).fill(0).map((_, index) => bfirstPage + index);
	// }

	get bvisiblePageNumbers(): number[] {
		if (!this.comrow || !Array.isArray(this.comrow)) {
			return [];
		}
	
		const bvisibleData = this.comrow.filter(data => data.visible);
		const btotalVisiblePages = 3;
		const bmiddlePage = Math.ceil(btotalVisiblePages / 2);
		const bfirstPage = Math.max(1, this.bcurrentPagee - bmiddlePage + 1);
		const blastPage = Math.min(this.btotalPages, bfirstPage + btotalVisiblePages - 1);
		return Array(blastPage - bfirstPage + 1).fill(0).map((_, index) => bfirstPage + index);
	}
	

	bchangePagep(page: number): void {
		if (page === -1 && this.bcurrentPagee > 1) {
			this.bcurrentPagee--;
		}
	}

	bchangePage(page: number): void {
		if (page > 0 && page <= this.btotalPages) {
			this.bcurrentPagee = page;
		}
	}

	bchangePagen(page: number): void {
		if (page === 1 && this.bcurrentPagee < this.btotalPages) {
			this.bcurrentPagee++;
		}
	}



	// Currency

	// search

	// searchTextD: string = '';

	// applyFilterD(event: any) {
	// 	const csearchText = event.target.value.toLowerCase();
	// 	this.searchTextD = csearchText;
	// 	if (csearchText === '') {
	// 		this.currow = this.originalCurrow;
	// 	} else {
	// 		this.currow = this.originalCurrow.filter((element: any) => {
	// 			const name = element[0].toLowerCase();
	// 			return name.includes(csearchText);
	// 			//startsWith
	// 		});
	// 	}
	// }

	searchTextD: string = '';
	filteredcurrowData: any[] = [];


	dnoSearchResults: boolean = false;
	

	applyFilterD(event: any) {
		const searchText = event.target.value.toLowerCase();
		this.searchTextC = searchText;

		if (searchText === '') {
			this.filteredcurrowData = [];
			this.dnoSearchResults = false;
		} else {
			this.filteredcurrowData = this.originalCurrow.filter((element: any) => {
				const name = element[0].toLowerCase();
				return name.includes(searchText);
			});
			this.dcurrentPagee = 1;
			this.dnoSearchResults = this.filteredcurrowData.length === 0;
		}
		this.dcalculateVisiblePageNumbers();
	}

	dcalculateVisiblePageNumbers() {
		if (this.filteredcurrowData.length === 0) {
			const totalVisiblePages = 3;
			const middlePage = Math.ceil(totalVisiblePages / 2);
			const firstPage = Math.max(1, this.ccurrentPagee - middlePage + 1);
			const lastPage = Math.min(this.ctotalPages, firstPage + totalVisiblePages - 1);
			this.cvisiblePageNumbers.splice(0, this.cvisiblePageNumbers.length); // Clear the array
			this.cvisiblePageNumbers.push(...Array(lastPage - firstPage + 1).fill(0).map((_, index) => firstPage + index));
		} else {
			this.cvisiblePageNumbers.splice(0, this.cvisiblePageNumbers.length);
		}
	}

	ccurrentPagee = 1;
	citemsPerPage = 20;


	searchTextE: string = '';
	enoSearchResults: boolean = false;
	filterednsecomrowData: any[] = [];

	ecalculateVisiblePageNumbers() {
		if (this.filterednsecomrowData.length === 0) {
			const totalVisiblePages = 3;
			const middlePage = Math.ceil(totalVisiblePages / 2);
			const firstPage = Math.max(1, this.dcurrentPagee - middlePage + 1);
			const lastPage = Math.min(this.dtotalPages, firstPage + totalVisiblePages - 1);
			this.dvisiblePageNumbers.splice(0, this.dvisiblePageNumbers.length); // Clear the array
			this.dvisiblePageNumbers.push(...Array(lastPage - firstPage + 1).fill(0).map((_, index) => firstPage + index));
		} else {
			this.dvisiblePageNumbers.splice(0, this.dvisiblePageNumbers.length);
		}
	}

		dcurrentPagee = 1;
		ditemsPerPage = 20;

	// pagination 



	// get ctotalPages(): number {
	// 	return Math.ceil(this.currow.length / this.citemsPerPage);
	// }

	// get ctotalPages(): number {
	// 	if (this.searchTextD === '') {
	// 		return Math.ceil(this.currow.length / this.citemsPerPage);
	// 	} else {
	// 		return Math.ceil(this.filteredcurrowData.length / this.citemsPerPage);
	// 	}
	// }

	get ctotalPages(): number {
		if (this.searchTextD === '') {
			return this.currow ? Math.ceil(this.currow.length / this.citemsPerPage) : 0;
		} else {
			return this.filteredcurrowData ? Math.ceil(this.filteredcurrowData.length / this.citemsPerPage) : 0;
		}
	}
	

	get cpageNumbers(): number[] {
		return Array(this.ctotalPages).fill(0).map((_, index) => index + 1);
	}


	get currowData(): any[] {
		if (this.filteredcurrowData.length === 0) {
			const startIndex = (this.ccurrentPagee - 1) * this.citemsPerPage;
			return this.currow.slice(startIndex, startIndex + this.citemsPerPage);
		} else {
			const startIndex = (this.ccurrentPagee - 1) * this.citemsPerPage;
			return this.filteredcurrowData.slice(startIndex, startIndex + this.citemsPerPage);
		}
	}

	// get cvisiblePageNumbers(): number[] {
	// 	const cvisibleData = this.currow.filter(data => data.visible);
	// 	const ctotalVisiblePages = 3;
	// 	const cmiddlePage = Math.ceil(ctotalVisiblePages / 2);
	// 	const cfirstPage = Math.max(1, this.ccurrentPagee - cmiddlePage + 1);
	// 	const clastPage = Math.min(this.ctotalPages, cfirstPage + ctotalVisiblePages - 1);
	// 	return Array(clastPage - cfirstPage + 1).fill(0).map((_, index) => cfirstPage + index);
	// }

	get cvisiblePageNumbers(): number[] {
		if (!this.currow || !Array.isArray(this.currow)) {
			return [];
		}
	
		const cvisibleData = this.currow.filter(data => data.visible);
		const ctotalVisiblePages = 3;
		const cmiddlePage = Math.ceil(ctotalVisiblePages / 2);
		const cfirstPage = Math.max(1, this.ccurrentPagee - cmiddlePage + 1);
		const clastPage = Math.min(this.ctotalPages, cfirstPage + ctotalVisiblePages - 1);
		return Array(clastPage - cfirstPage + 1).fill(0).map((_, index) => cfirstPage + index);
	}
	


	cchangePagep(page: number): void {
		if (page === -1 && this.ccurrentPagee > 1) {
			this.ccurrentPagee--;
		}
	}

	cchangePage(page: number): void {
		if (page > 0 && page <= this.ctotalPages) {
			this.ccurrentPagee = page;
		}
	}

	cchangePagen(page: number): void {
		if (page === 1 && this.ccurrentPagee < this.ctotalPages) {
			this.ccurrentPagee++;
		}
	}



	get dtotalPages(): number {
		if (this.searchTextD === '') {
			return this.nsecomrow ? Math.ceil(this.nsecomrow.length / this.ditemsPerPage) : 0;
		} else {
			return this.filteredcurrowData ? Math.ceil(this.filteredcurrowData.length / this.ditemsPerPage) : 0;
		}
	}
	

	get dpageNumbers(): number[] {
		return Array(this.dtotalPages).fill(0).map((_, index) => index + 1);
	}

	get nescomrowData(): any[] {
		if (this.filterednsecomrowData.length === 0) {
			const startIndex = (this.dcurrentPagee - 1) * this.ditemsPerPage;
			return this.nserow.slice(startIndex, startIndex + this.ditemsPerPage);
		} else {
			const startIndex = (this.dcurrentPagee - 1) * this.ditemsPerPage;
			return this.filterednsecomrowData.slice(startIndex, startIndex + this.ditemsPerPage);
		}
	}

	get dvisiblePageNumbers(): number[] {
		if (!this.nserow || !Array.isArray(this.nserow)) {
			return [];
		}
	
		const cvisibleData = this.nserow.filter(data => data.visible);
		const ctotalVisiblePages = 3;
		const cmiddlePage = Math.ceil(ctotalVisiblePages / 2);
		const cfirstPage = Math.max(1, this.dcurrentPagee - cmiddlePage + 1);
		const clastPage = Math.min(this.dtotalPages, cfirstPage + ctotalVisiblePages - 1);
		return Array(clastPage - cfirstPage + 1).fill(0).map((_, index) => cfirstPage + index);
	}
	


	dchangePagep(page: number): void {
		if (page === -1 && this.dcurrentPagee > 1) {
			this.dcurrentPagee--;
		}
	}

	dchangePage(page: number): void {
		if (page > 0 && page <= this.dtotalPages) {
			this.dcurrentPagee = page;
		}
	}

	dchangePagen(page: number): void {
		if (page === 1 && this.dcurrentPagee < this.dtotalPages) {
			this.dcurrentPagee++;
		}
	}


	// Equity Sorting

	SortingDirections: { [key: string]: 'asc' | 'desc' } = {};
	currentSortedColumn: string | null = null;
	currentHoveredColumn: string | null = null;

	equityTableSorting(column: any) {
		if (this.currentSortedColumn !== column) {
			this.currentSortedColumn = column;
			this.SortingDirections[column] = 'asc';
		} else {
			this.SortingDirections[column] = this.SortingDirections[column] === 'asc' ? 'desc' : 'asc';
		}
		this.onEquitySort({ column, direction: this.SortingDirections[column] as 'asc' | 'desc' });
	}

	onEquitySort({ column, direction }: SortEvent) {
		this.headers.forEach(header => {
			if (header.sortable !== column) {
				header.direction = '';
			} else if (direction === undefined) {
				header.direction = 'desc';
			}
		});

		if (direction === '' || column === '') {
			this.equityrow = [...this.equityrow];
		} else {
			this.equityrow = [...this.equityrow].sort((a, b) => {
				const valueA = a[column];
				const valueB = b[column];
				if (!isNaN(valueA) && !isNaN(valueB)) {
					return direction === 'asc' ? valueA - valueB : valueB - valueA;
				} else {
					return direction === 'asc' ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA);
				}
			});
		}
	}

	// Fno Sorting

	fnoTableSorting(column: any) {
		if (this.currentSortedColumn !== column) {
			this.currentSortedColumn = column;
			this.SortingDirections[column] = 'asc';
		} else {
			this.SortingDirections[column] = this.SortingDirections[column] === 'asc' ? 'desc' : 'asc';
		}
		this.onFnoSort({ column, direction: this.SortingDirections[column] as 'asc' | 'desc' });
	}

	onFnoSort({ column, direction }: SortEvent) {
		this.headers.forEach(header => {
			if (header.sortable !== column) {
				header.direction = '';
			} else if (direction === undefined) {
				header.direction = 'desc';
			}
		});

		if (direction === '' || column === '') {
			this.fnorow = [...this.fnorow];
		} else {
			this.fnorow = [...this.fnorow].sort((a, b) => {
				const valueA = a[column];
				const valueB = b[column];
				if (!isNaN(valueA) && !isNaN(valueB)) {
					return direction === 'asc' ? valueA - valueB : valueB - valueA;
				} else {
					return direction === 'asc' ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA);
				}
			});
		}
	}



	// comrow Sorting

	comrowTableSorting(column: any) {
		if (this.currentSortedColumn !== column) {
			this.currentSortedColumn = column;
			this.SortingDirections[column] = 'asc';
		} else {
			this.SortingDirections[column] = this.SortingDirections[column] === 'asc' ? 'desc' : 'asc';
		}
		this.onComrowSort({ column, direction: this.SortingDirections[column] as 'asc' | 'desc' });
	}

	onComrowSort({ column, direction }: SortEvent) {
		this.headers.forEach(header => {
			if (header.sortable !== column) {
				header.direction = '';
			} else if (direction === undefined) {
				header.direction = 'desc';
			}
		});

		if (direction === '' || column === '') {
			this.comrow = [...this.comrow];
		} else {
			this.comrow = [...this.comrow].sort((a, b) => {
				const valueA = a[column];
				const valueB = b[column];
				if (!isNaN(valueA) && !isNaN(valueB)) {
					return direction === 'asc' ? valueA - valueB : valueB - valueA;
				} else {
					return direction === 'asc' ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA);
				}
			});
		}
	}



	// currow Sorting

	currowTableSorting(column: any) {
		if (this.currentSortedColumn !== column) {
			this.currentSortedColumn = column;
			this.SortingDirections[column] = 'asc';
		} else {
			this.SortingDirections[column] = this.SortingDirections[column] === 'asc' ? 'desc' : 'asc';
		}
		this.onCurrowSort({ column, direction: this.SortingDirections[column] as 'asc' | 'desc' });
	}

	onCurrowSort({ column, direction }: SortEvent) {
		this.headers.forEach(header => {
			if (header.sortable !== column) {
				header.direction = '';
			} else if (direction === undefined) {
				header.direction = 'desc';
			}
		});

		if (direction === '' || column === '') {
			this.currow = [...this.currow];
		} else {
			this.currow = [...this.currow].sort((a, b) => {
				const valueA = a[column];
				const valueB = b[column];
				if (!isNaN(valueA) && !isNaN(valueB)) {
					return direction === 'asc' ? valueA - valueB : valueB - valueA;
				} else {
					return direction === 'asc' ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA);
				}
			});
		}
	}


	//nsecomrow Sorting


	nsecomrowTableSorting(column: any) {
	if (this.currentSortedColumn !== column) {
		this.currentSortedColumn = column;
		this.SortingDirections[column] = 'asc';
	} else {
		this.SortingDirections[column] = this.SortingDirections[column] === 'asc' ? 'desc' : 'asc';
	}
	this.onNsecomowSort({ column, direction: this.SortingDirections[column] as 'asc' | 'desc' });
	}

	onNsecomowSort({ column, direction }: SortEvent) {
		this.headers.forEach(header => {
			if (header.sortable !== column) {
				header.direction = '';
			} else if (direction === undefined) {
				header.direction = 'desc';
			}
		});

		if (direction === '' || column === '') {
			this.nserow = [...this.nserow];
		} else {
			this.nserow = [...this.nserow].sort((a, b) => {
				const valueA = a[column];
				const valueB = b[column];
				if (!isNaN(valueA) && !isNaN(valueB)) {
					return direction === 'asc' ? valueA - valueB : valueB - valueA;
				} else {
					return direction === 'asc' ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA);
				}
			});
		}
	}



}